<template>
  <div class="background">
    <main class="contents">
      <div
        id="summary"
        class="card"
      >
        <div
          v-if="dmpiLinks.enabled === true
            && dmpiLinks.serviceContractUrl !== null
            && dmpiLinks.serviceContractUrl !== ''
            && dmpiLinks.topBanner !== null
            && dmpiLinks.topBanner !== ''
            && !this.$store.state.isReadOnly"
        >
          <a
            class="dmpiLinks"
            target="_blank"
            :href="dmpiLinks.serviceContractUrl"
          >
            <img
              id="topImage"
              width="100%"
              :src="dmpiLinks.topBanner"
            >
          </a>
        </div>
        <!-- SERVICES APPROVED AT DEALERSHIP -->
        <div
          v-if="approvedAtDealership.count"
          class="row"
        >
          <div class="previous">
            <p class="item">
              {{ $t("services_approved_at_dealership") }}
              <span
                v-if="$route.name === 'additional-summary'"
                class="bold"
              >
                ({{ approvedAtDealership.count }})
              </span>
              <span class="taxes">
                {{ $t("taxes_and_fees_included") }}
              </span>
            </p>
            <button
              class="toggle"
              @click="toggleApprovedAtDealership()"
            >
              <img
                class="chevron"
                :class="{'open' : approvedAtDealershipExpanded}"
                src="@/assets/images/chevron-down.svg"
                aria-hidden="true"
              >
            </button>
          </div>
          <p class="price">
            {{ approvedAtDealership.total }}
          </p>
        </div>
        <transition-height>
          <div
            v-if="approvedAtDealershipExpanded"
            class="list"
          >
            <template v-for="service in servicesApprovedAtDealershipFiltered">
              <!-- Parent Service -->
              <div
                :key="service.id"
                class="row"
              >
                <p class="item">
                  <span v-if="service.isStandAloneSublet === true && service.isSubletLabor !== true" >{{ $t("sublet") }} - </span>{{ service.name }}
                </p>
                <p
                  v-if="getServiceDisplayPrice(service)"
                  class="price"
                >
                  {{ getServiceDisplayPrice(service) }}
                </p>
              </div>
              <!-- Child Sublets -->
              <div
                v-if="service.subletServices && service.subletServices.length > 0"
                :key="service.id + '-sublets'"
                class="sublet-group"
              >
                <div
                  v-for="sublet in service.subletServices"
                  :key="sublet.id"
                  class="row sublet-row"
                >
                  <p class="item">
                    <span v-if="sublet.isSubletLabor !== true" >{{ $t("sublet") }} - </span>{{ sublet.name }}
                  </p>
                  <p
                    v-if="getServiceDisplayPrice(sublet)"
                    class="price"
                  >
                    {{ getServiceDisplayPrice(sublet) }}
                  </p>
                </div>
              </div>
            </template>
          </div>
        </transition-height>
        <div
          v-if="servicesApprovedAtDealershipFiltered.length"
          class="divider"
        />

        <template v-if="$route.name === 'summary'">
          <div class="row bold">
            <div class="previous">
              <p class="item">
                {{ $t("estimate") }}
              </p>
              <button
                v-if="firstApprovedServicesWithSublets.length"
                class="toggle"
                @click="toggleFirstApproved()"
              >
                <img
                  class="chevron"
                  :class="{'open' : firstApprovedExpanded}"
                  src="@/assets/images/chevron-down.svg"
                  aria-hidden="true"
                >
              </button>
            </div>
            <p class="price">
              {{ formatCurrency(this.$store.getters.total.inspection) }}
            </p>
          </div>
          <transition-height>
            <div
              v-if="firstApprovedExpanded"
              class="list"
            >
              <template v-for="service in firstApprovedServicesWithSublets">
                <!-- Parent Service -->
                <div
                  :key="service.id"
                  class="row"
                >
                  <p class="item">
                    <span v-if="service.isStandAloneSublet === true && service.isSubletLabor !== true" >{{ $t("sublet") }} - </span>{{ service.name }}
                  </p>
                  <p
                    v-if="getServiceDisplayPrice(service)"
                    class="price"
                  >
                    {{ getServiceDisplayPrice(service) }}
                  </p>
                </div>
                <!-- Child Sublets -->
                <div
                  v-if="service.subletServices && service.subletServices.length > 0"
                  :key="service.id + '-sublets'"
                  class="sublet-group"
                >
                  <div
                    v-for="sublet in service.subletServices"
                    :key="sublet.id"
                    class="row sublet-row"
                  >
                    <p class="item">
                      <span v-if="sublet.isSubletLabor !== true" >{{ $t("sublet") }} - </span>{{ sublet.name }}
                    </p>
                    <p
                      v-if="getServiceDisplayPrice(sublet)"
                      class="price"
                    >
                      {{ getServiceDisplayPrice(sublet) }}
                    </p>
                  </div>
                </div>
              </template>
            </div>
          </transition-height>
          <template v-if="coreCharges > 0">
            <div
              class="row"
            >
              <div class="item">
                {{ $t("core_charge") }}
              </div>
              <div class="price">
                {{ formatCurrency(coreCharges) }}
              </div>
            </div>
            <div
              class="row"
            >
              <div class="item">
                {{ $t("core_return_credit") }}
              </div>
              <div class="price">
                {{ formatSignedCurrency(-coreCharges) }}
              </div>
            </div>
            <div class="divider" />
          </template>
          <div
            class="row"
          >
            <div class="item">
              {{ $t("additional_taxes_and_fees") }}
            </div>
            <div class="price">
              {{ formatCurrency(this.$store.state.tax.newlyApproved) }}
            </div>
          </div>
          <div
            class="row"
          >
            <div class="item">
              {{ $t("hazardous_materials_fee") }}
            </div>
            <div class="price">
              {{ formatCurrency(this.$store.state.approvedHazardousMaterialFee) }}
            </div>
          </div>
        </template>
        <template v-if="$route.name === 'additional-summary'">
          <!-- PREVIOUSLY APPROVED SERVICES -->
          <template v-if="previouslyApproved.count">
            <div
              class="row"
            >
              <div class="previous">
                <p class="item">
                  {{ $t("previously_approved_items") }}
                  <span
                    class="bold"
                  >
                    ({{ previouslyApproved.count }})
                  </span>
                </p>
                <button
                  class="toggle"
                  @click="togglePreviouslyApproved()"
                >
                  <img
                    class="chevron"
                    :class="{'open' : previouslyApprovedExpanded}"
                    src="@/assets/images/chevron-down.svg"
                    aria-hidden="true"
                  >
                </button>
              </div>
              <p class="price">
                {{ previouslyApproved.preTax }}
              </p>
            </div>
            <transition-height>
              <div
                v-if="previouslyApprovedExpanded"
                class="list"
              >
                <template v-for="service in previouslyApproved.services">
                  <!-- Parent Service -->
                  <div
                    :key="service.id"
                    class="row"
                  >
                    <p class="item">
                      <span v-if="service.isStandAloneSublet === true && service.isSubletLabor !== true" >{{ $t("sublet") }} - </span>{{ service.name }}
                    </p>
                    <p
                      v-if="getServiceDisplayPrice(service)"
                      class="price"
                    >
                      {{ getServiceDisplayPrice(service) }}
                    </p>
                  </div>
                  <!-- Child Sublets -->
                  <div
                    v-if="service.subletServices && service.subletServices.length > 0"
                    :key="service.id + '-sublets'"
                    class="sublet-group"
                  >
                    <div
                      v-for="sublet in service.subletServices"
                      :key="sublet.id"
                      class="row sublet-row"
                    >
                      <p class="item">
                        <span v-if="sublet.isSubletLabor !== true" >{{ $t("sublet") }} - </span>{{ sublet.name }}
                      </p>
                      <p
                        v-if="getServiceDisplayPrice(sublet)"
                        class="price"
                      >
                        {{ getServiceDisplayPrice(sublet) }}
                      </p>
                    </div>
                  </div>
                </template>
              </div>
            </transition-height>
            <div class="divider" />
            <div
              class="row indented"
            >
              <div class="item">
                {{ $t("additional_taxes_and_fees") }}
              </div>
              <div class="price">
                <template v-if="loading.getTax">
                  <dot-dot-dot-spinner />
                </template>
                <template v-else>
                  {{ previouslyApproved.tax }}
                </template>
              </div>
            </div>
              <div
              v-if="hazardousMaterialsFee > 0"
              class="row indented"
            >
              <div class="item">
                {{ $t("hazardous_materials_fee") }}
              </div>
              <div class="price">
                {{ formatCurrency(this.$store.state.approvedHazardousMaterialFee) }}
              </div>
            </div>
            <div class="row bold indented pretax">
              <p class="item">
                {{ $t("total") }}
              </p>
              <p class="price">
                <template v-if="loading.getTax">
                  <dot-dot-dot-spinner />
                </template>
                <template v-else>
                  {{ previouslyApproved.total }}
                </template>
              </p>
            </div>
            <div
              class="divider"
            />
          </template>

          <!-- NEWLY APPROVED SERVICES -->
          <div
            class="row"
          >
            <div class="previous">
              <p class="item">
                {{ $t("newly_approved_items") }}
                <span
                  class="bold"
                >
                  ({{ newlyApproved.count }})
                </span>
              </p>
              <button
                v-if="newlyApproved.count"
                class="toggle"
                @click="toggleNewlyApproved()"
              >
                <img
                  class="chevron"
                  :class="{'open' : newlyApprovedExpanded}"
                  src="@/assets/images/chevron-down.svg"
                  aria-hidden="true"
                >
              </button>
            </div>
            <p class="price">
              {{ newlyApproved.preTax }}
            </p>
          </div>
          <transition-height>
            <div
              v-if="newlyApprovedExpanded"
              class="list"
            >
              <template v-for="service in newlyApproved.services">
                <!-- Parent Service -->
                <div
                  :key="service.id"
                  class="row"
                >
                  <p class="item">
                    <span v-if="service.isStandAloneSublet === true && service.isSubletLabor !== true" >{{ $t("sublet") }} - </span>{{ service.name }}
                  </p>
                  <p
                    v-if="getServiceDisplayPrice(service)"
                    class="price"
                  >
                    {{ getServiceDisplayPrice(service) }}
                  </p>
                </div>
                <!-- Child Sublets -->
                <div
                  v-if="service.subletServices && service.subletServices.length > 0"
                  :key="service.id + '-sublets'"
                  class="sublet-group"
                >
                  <div
                    v-for="sublet in service.subletServices"
                    :key="sublet.id"
                    class="row sublet-row"
                  >
                    <p class="item">
                      <span v-if="sublet.isSubletLabor !== true" >{{ $t("sublet") }} - </span>{{ sublet.name }}
                    </p>
                    <p
                      v-if="getServiceDisplayPrice(sublet)"
                      class="price"
                    >
                      {{ getServiceDisplayPrice(sublet) }}
                    </p>
                  </div>
                </div>
              </template>
            </div>
          </transition-height>
          <div class="divider" />
          <div
            class="row indented"
          >
            <p class="item">
              {{ $t("additional_taxes_and_fees") }}
            </p>
            <p class="price">
              <template v-if="loading.getTax">
                <dot-dot-dot-spinner />
              </template>
              <template v-else>
                {{ newlyApproved.tax }}
              </template>
            </p>
          </div>
          <div class="row bold indented pretax">
            <p class="item">
              {{ $t("total") }}
            </p>
            <p class="price">
              <template v-if="loading.getTax">
                <dot-dot-dot-spinner />
              </template>
              <template v-else>
                {{ newlyApproved.total }}
              </template>
            </p>
          </div>
        </template>

        <div class="divider" />

        <div class="row total bold" :style="this.$store.state.guestPaymentSurchargePriceBreakdown ? { marginTop: '1em' } : {}">
          <p class="item" :style="this.$store.state.guestPaymentSurchargePriceBreakdown ? { margin: '0px' } : {}">
            {{ $route.name === 'summary' ? $t("total_cost") : $t("total_updated_cost") }}
          </p>
          <p class="price">
            <template v-if="loading.getTax">
              <dot-dot-dot-spinner />
            </template>
            <template v-else>
              {{ total }}
            </template>
          </p>
        </div>
        <div v-if="this.$store.state.guestPaymentSurchargePriceBreakdown" class="row total surcharge">
          <p class="no-margin">
            {{ $t("total_cost_no_surcharge") }}
          </p>
          <p class="no-margin">
            <template v-if="loading.getTax">
              <dot-dot-dot-spinner />
            </template>
            <template v-else>
              {{ total }}
            </template>
          </p>
        </div>
        <div v-if="this.$store.state.guestPaymentSurchargePriceBreakdown" class="row total surcharge">
          <p class="no-margin">
            {{ $t("total_cost_with_surcharge") }}
          </p>
          <p class="no-margin">
            <template v-if="loading.getTax">
              <dot-dot-dot-spinner />
            </template>
            <template v-else>
              {{ totalWithSurcharge }}
            </template>
          </p>
        </div>

        <div v-if="this.$store.state.guestPaymentSurchargeDisclaimer" class="total surcharge disclaimer">
          <strong>{{ $t("disclaimer") }}</strong><br>{{ this.$store.state.guestPaymentSurchargeDisclaimer }}
        </div>

        <div v-if="!this.$store.state.isReadOnly" id="payment-method-messaging-element" a-data="dmpi-summary-buy-now-pay-later-banner"></div>
      </div>
      <div
        v-if="dmpiLinks.enabled === true
          && dmpiLinks.nnaCreditCardApplicationUrl !== null
          && dmpiLinks.nnaCreditCardApplicationUrl !== ''
          && dmpiLinks.bottomBanner !== null
          && dmpiLinks.bottomBanner !== ''
          && !this.$store.state.isReadOnly"
      >
        <a
          class="dmpiLinks"
          target="_blank"
          :href="dmpiLinks.nnaCreditCardApplicationUrl"
        >
          <img
            id="visaImage"
            :src="dmpiLinks.bottomBanner"
            width="100%"
          >
        </a>
      </div>
      <div
        v-if="dmpiLinks.enabled === true
          && dmpiLinks.sunbitServiceFinancingUrl !== null
          && dmpiLinks.sunbitServiceFinancingUrl !== ''
          && dmpiLinks.sunbitBanner !== null
          && dmpiLinks.sunbitBanner !== ''
          && !this.$store.state.isReadOnly"
      >
        <a
          class="dmpiLinks"
          target="_blank"
          :href="dmpiLinks.sunbitServiceFinancingUrl"
        >
          <img
            id="sunbitImage"
            :src="dmpiLinks.sunbitBanner"
            width="100%"
          >
        </a>
      </div>

      <!-- SIGNATURE -->
      <div
        v-if="count.actionable"
        class="divider"
      />
      <div
        v-if="count.actionable"
        class="signature"
      >
        <div class="legend">
          <p class="prompt">
            {{ $t("please_sign_below") }}
          </p>
          <div class="controls">
            <button
              v-if="!this.$store.state.isReadOnly"
              class="clear"
              @click="clear()"
            >
              {{ $t("clear") }}
            </button>
            <button
              v-if="!this.$store.state.isReadOnly"
              class="sign"
              :disabled="panned"
              @click="sign()"
              @keydown.enter="sign()"
            >
              {{ $t("click_to_sign") }}
            </button>
          </div>
        </div>
        <div class="wrapper">
          <canvas
            ref="canvas"
            class="panel"
            v-if="(!this.$store.state.customerSignature)"
          />
          <div
            v-if="!this.$store.state.isCompletedByAdvisor && !this.$store.state.isReadOnly"
            v-show="printed"
            ref="printed"
            class="printed"
          >
            <p>
              {{ `${customer.firstName} ${customer.lastName}` }}
            </p>
          </div>
          <div
            v-if="this.$store.state.isCompletedByAdvisor"
            ref="printed"
            class="printed"
          >
            <p>
              {{ $t("completed_via_advisor") }}
            </p>
          </div>
          <img v-if="!!this.$store.state.customerSignature" :src="this.$store.state.customerSignature" alt="Signature" />
          <img
            src="@/assets/images/signature.svg"
            alt="sample signature"
            class="sample"
          >
        </div>
        <input
          id="acknowledgement"
          v-model="accepted"
          type="checkbox"
          @click.stop
        >
        <label
          for="acknowledgement"
          class="checkbox"
          @click.stop
        >
          <div class="box" v-if="!this.$store.state.isReadOnly">
            <img
              src="@/assets/images/check.svg"
              alt="check"
              class="check"
            >
          </div>
          <p class="text">
            {{ $t("i_acknowledge") }} <router-link
              :to="{name: 'terms-and-conditions'}"
              class="link"
              @click.stop
            >
              {{ $t("terms_and_conditions") }}.
            </router-link>
          </p>
        </label>
      </div>

      <!-- ERROR -->
      <div class="error">
        <transition-height>
          <p
            v-if="error"
            class="text"
          >
            {{ $t("please_sign_in_and_accept") }}
          </p>
        </transition-height>
      </div>

      <!-- BUTTON -->
      <button
        v-if="!this.$store.state.isReadOnly"
        class="button cta green"
        :disabled="this.$store.state.isReadOnly? this.$store.state.isReadOnly : loading.sendServices"
        @click="approve()"
      >
        {{ count.actionable ? $t("approve") : $t("next") }}
      </button>
    </main>
  </div>
</template>

<script>
import Vue from 'vue'
import Pad from 'signature_pad'
import TransitionHeight from '@/components/TransitionHeight.vue'
import DotDotDotSpinner from '@/components/DotDotDotSpinner.vue'
import Hammer from 'hammerjs'
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { getTotal, formatCurrency, getServiceDisplayPrice } from '@/mixins.js'
import { Elements, PaymentMethodMessagingElement } from '@vue-stripe/vue-stripe'
import { loadStripe } from "@stripe/stripe-js"
import { stripeCadPublishableKey, stripeUsdPublishableKey } from '@/environment.js'

export default Vue.extend({
  name: 'Summary',
  components: {
    DotDotDotSpinner,
    TransitionHeight,
    Elements
  },
  mixins: [getTotal, formatCurrency, getServiceDisplayPrice],
  data: () => ({
    pad: null,
    panned: false,
    printed: false,
    error: false,
    approvedAtDealershipExpanded: false,
    previouslyApprovedExpanded: false,
    newlyApprovedExpanded: false,
    firstApprovedExpanded: false,
    stripe: null,
  }),
  computed: {
    accepted: {
      get () {
        return this.$store.state.acceptedTermsAndConditions
      },
      set (accepted) {
        if (accepted) {
          this.acceptTermsAndConditions()
          this.logEvent('Accepted terms and conditions')
        } else {
          this.declineTermsAndConditions()
          this.logEvent('Declined terms and conditions')
        }
      }
    },
    ...mapState([
      'customer',
      'loading',
      'services',
      'dmpiLinks',
      'dealer',
      'approvedHazardousMaterialFee',
      'hazardousMaterialsFee'
    ]),
    ...mapGetters([
      'count',
      'categoryServices',
      'additionalServices',
      'actionableDeferredServices',
      'deferredServices',
      'previouslyApprovedServices',
      'servicesApprovedAtDealership',
      'firstApprovedServices'
    ]),
    // Get services with their subletServices attached (not flattened)
    firstApprovedServicesWithSublets () {
      const services = this.$store.state.services
      let result = []
      
      services.forEach((service) => {
        if (service.category !== '3' && service.category !== '4') {
          if (service.subServices) {
            service.subServices.forEach((subService) => {
              // Skip child sublets - they should only appear under their parent via subletServices
              if (subService.parentServiceLineIdForSublet !== null && subService.parentServiceLineIdForSublet !== undefined) {
                return
              }
              if (subService.isSelected) {
                result.push(subService)
              }
            })
          } else {
            // Skip child sublets - they should only appear under their parent via subletServices
            if (service.parentServiceLineIdForSublet !== null && service.parentServiceLineIdForSublet !== undefined) {
              return
            }
            if (service.isSelected) {
              if (service.category !== '1' && service.category !== '2') {
                result.push(service)
              }
            }
          }
        }
      })
      
      return result
    },
    // Get services approved at dealership without duplicates
    // Filters out services that are already child sublets of other services
    // and removes duplicate standalone sublets
    servicesApprovedAtDealershipFiltered () {
      const services = this.servicesApprovedAtDealership
      
      // Collect all child sublet IDs to filter them out from the main list
      const childSubletIds = new Set()
      services.forEach((service) => {
        if (service.subletServices && service.subletServices.length > 0) {
          service.subletServices.forEach((sublet) => {
            childSubletIds.add(sublet.id)
          })
        }
      })
      
      // Also filter out duplicate standalone sublets by base ID
      const seenBaseIds = new Map()
      const standaloneSubletDuplicateIds = new Set()
      
      services.forEach((service) => {
        if (service.isStandAloneSublet === true) {
          const numericMatch = service.id.match(/^(\d+)/)
          if (numericMatch) {
            const baseId = numericMatch[1]
            const hasSuffix = service.id.includes('-')
            
            if (seenBaseIds.has(baseId)) {
              const existing = seenBaseIds.get(baseId)
              const existingHasSuffix = existing.id.includes('-')
              
              if (hasSuffix && !existingHasSuffix) {
                standaloneSubletDuplicateIds.add(service.id)
              } else if (!hasSuffix && existingHasSuffix) {
                standaloneSubletDuplicateIds.add(existing.id)
                seenBaseIds.set(baseId, service)
              } else {
                standaloneSubletDuplicateIds.add(service.id)
              }
            } else {
              seenBaseIds.set(baseId, service)
            }
          }
        }
      })
      
      // Filter out child sublets (by parentServiceLineIdForSublet), child sublet IDs, and duplicate standalone sublets
      return services.filter((service) => 
        (service.parentServiceLineIdForSublet === null || service.parentServiceLineIdForSublet === undefined) &&
        !childSubletIds.has(service.id) && 
        !standaloneSubletDuplicateIds.has(service.id)
      )
    },
    approvedAtDealership () {
      let services = this.servicesApprovedAtDealershipFiltered
      // Include sublet prices in total calculation
      let total = this.getTotal(services)
      services.forEach((service) => {
        if (service.subletServices && service.subletServices.length > 0) {
          service.subletServices.forEach((sublet) => {
            total += sublet.price || 0
          })
        }
      })

      return {
        services,
        count: services.length,
        total: this.formatCurrency(total)
      }
    },
    newlyApproved () {
      let services = [
        ...this.additionalServices,
        ...this.actionableDeferredServices
      ]
        .filter(service => {
          const selected = service.isSelected
          const actionable = this.getServiceDisplayPrice(service) !== false
          return selected && actionable
        })
      let pretax = this.getTotal(services)
      let tax = this.$store.state.tax.newlyApproved

      return {
        services,
        count: services.length,
        tax: this.formatCurrency(tax),
        preTax: this.formatCurrency(pretax),
        total: this.formatCurrency(pretax + tax)
      }
    },
    previouslyApproved () {
      let services = this.$store.getters.previouslyApprovedServices
      let pretax = this.getTotal(services)
      let tax = this.$store.state.tax.previouslyApproved

      return {
        services,
        count: services.length,
        tax: this.formatCurrency(tax),
        preTax: this.formatCurrency(pretax),
        total: this.formatCurrency(pretax + tax)
      }
    },
    total () {
      let total = 0
      let formatted = ''
      if (this.$route.name === 'summary') {
        total = this.$store.getters.total.service +
          this.$store.getters.total.inspection +
          this.$store.state.tax.newlyApproved+
          this.$store.state.approvedHazardousMaterialFee
        formatted = this.formatCurrency(total)
      }
      if (this.$route.name === 'additional-summary') {
        total = this.$store.getters.total.service +
          this.$store.getters.total.inspection +
          this.$store.state.tax.newlyApproved +
          this.$store.state.tax.previouslyApproved+
          this.$store.state.approvedHazardousMaterialFee
        formatted = this.formatCurrency(total)
      }
      return formatted
    },
    totalWithSurcharge () {
      let total = 0
      let formatted = ''
      const surchargeMult = 1 + this.$store.state.guestPaymentSurchargeAmountOnline / 100
      if (this.$route.name === 'summary') {
        total = this.$store.getters.total.service +
          this.$store.getters.total.inspection +
          this.$store.state.tax.newlyApproved +
          this.$store.state.approvedHazardousMaterialFee
        formatted = this.formatCurrency(total * surchargeMult)
      }
      if (this.$route.name === 'additional-summary') {
        total = this.$store.getters.total.service +
          this.$store.getters.total.inspection +
          this.$store.state.tax.newlyApproved +
          this.$store.state.tax.previouslyApproved +
          this.$store.state.approvedHazardousMaterialFee
        formatted = this.formatCurrency(total * surchargeMult)
      }
      return formatted
    },
    coreCharges () {
      return Number(this.$store.state.tax.coreCharges) || 0
    }
  },
  watch: {
    // Watch for conditions to load BNPL form elements (moved from computed property)
    '$store.state.isSummaryReload': {
      handler (newVal) {
        if (newVal && this.$store.state.isGuestPaymentEnabled === true && !this.$store.state.isReadOnly) {
          this.$nextTick(() => {
            this.loadBNPLFormElements()
          })
        }
      },
      immediate: false
    }
  },
  mounted () {
    if (this.count.actionable) {
      this.buildPad()
    }
    window.addEventListener('resize', this.setCanvasBackground)
    this.logEvent('Started viewing summary page')
    if (this.$store.state.isGuestPaymentEnabled === true && !this.$store.state.isReadOnly) {
      this.$store.state.isSummaryReload = true
      this.loadBNPLFormElements()
    }
    if (!!this.$store.state.customerSignature && this.$store.state.isReadOnly) {
      this.bindSignature()
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setCanvasBackground)
    this.logEvent('Finished viewing summary page')
  },
  methods: {
    ...mapMutations([
      'setSignature',
      'declineTermsAndConditions',
      'acceptTermsAndConditions',
      'logEvent'
    ]),
    ...mapActions({
      sendServices: 'sendServices',
      getStripePaymentMethods: 'getStripePaymentMethods'
    }),
    loadBNPLFormElements () {
      // Only proceed if on summary or additional-summary route
      if (this.$route.name !== 'summary' && this.$route.name !== 'additional-summary') {
        return
      }
      
      if (this.$store.state.dealer.currencyCode && this.$store.state.dealer.currencyCode !== '') {
        if (this.$store.state.dealer.currencyCode.toUpperCase() === 'CAD') {
          this.stripe = Stripe(stripeCadPublishableKey)
        }
        else {
          this.stripe = Stripe(stripeUsdPublishableKey)
        }
        var elements = this.stripe.elements()
        if (this.$store.state.stripePaymentMethods.length > 0) {
          let total = 0
          if (this.$route.name === 'summary') {
            total = this.$store.getters.total.service +
              this.$store.getters.total.inspection +
              this.$store.state.tax.newlyApproved
          }
          if (this.$route.name === 'additional-summary') {
            total = this.$store.getters.total.service +
              this.$store.getters.total.inspection +
              this.$store.state.tax.newlyApproved +
              this.$store.state.tax.previouslyApproved
          }
          var lowerCasePaymentMethodTypes = this.$store.state.stripePaymentMethods.map(v => v.toLowerCase())
          const options = {
            amount: Math.floor(total * 100),
            currency: this.$store.state.dealer.currencyCode.toUpperCase(),
            paymentMethodTypes: lowerCasePaymentMethodTypes,
            countryCode: this.$store.state.dealer.countryId.toUpperCase()
          }
          const paymentMessageElement = elements.create('paymentMethodMessaging', options)
          // Check if DOM element exists before mounting
          setTimeout(() => {
            const targetElement = document.querySelector('#payment-method-messaging-element')
            if (targetElement) {
              paymentMessageElement.mount('#payment-method-messaging-element')
            }
          }, 500)
        }
      }
    },
  // Bind signature to canvas (use the saved image data)
  bindSignature() {
      var signatureCtx = this.$refs.canvas.getContext('2d');
      const image = new Image();
      image.src = this.$store.state.customerSignature;
      image.onload = () => {
        this.signatureCtx.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height); // Clear any previous content
        this.signatureCtx.drawImage(image, 0, 0);
      };
    },
    toggleApprovedAtDealership () {
      this.approvedAtDealershipExpanded = !this.approvedAtDealershipExpanded
    },
    togglePreviouslyApproved () {
      this.previouslyApprovedExpanded = !this.previouslyApprovedExpanded
    },
    toggleNewlyApproved () {
      this.newlyApprovedExpanded = !this.newlyApprovedExpanded
    },
    toggleFirstApproved () {
      this.firstApprovedExpanded = !this.firstApprovedExpanded
    },
    clear () {
      if (!this.pad.isEmpty() || this.panned) {
        const context = this.$refs.canvas.getContext('2d')
        const canvas = this.$refs.canvas
        this.panned = false
        this.printed = false
        this.pad.off()
        context.clearRect(0, 0, canvas.width, canvas.height)
        this.buildPad()
      }
    },
    buildPad () {
      this.pad = new Pad(this.$refs.canvas, { backgroundColor: '#f7f7fa' })
      this.setCanvasBackground()
      const hammer = new Hammer(this.$refs.canvas)
      hammer.on('pan', this.signed)
    },
    setCanvasBackground () {
      const canvas = this.$refs.canvas
      const context = canvas.getContext('2d')
      canvas.width = canvas.offsetWidth
      canvas.height = canvas.offsetHeight
      if (window.innerWidth < 992) {
        context.fillStyle = getComputedStyle(canvas).getPropertyValue('--grey-light-background')
      } else {
        context.fillStyle = getComputedStyle(canvas).getPropertyValue('--white')
      }
      context.fillRect(0, 0, canvas.width, canvas.height)
    },
    sign () {
      this.printed = true

      let name = `${this.customer.firstName} ${this.customer.lastName}`
      const canvas = this.$refs.canvas
      const canvasWidth = canvas.offsetWidth
      const canvasHeight = canvas.offsetHeight
      const context = canvas.getContext('2d')
      context.font = 'italic 2em serif'
      context.fillStyle = getComputedStyle(canvas).getPropertyValue('--black')
      context.textAlign = 'center'
      context.fillText(name, (canvasWidth / 2), (canvasHeight / 2))

      this.panned = true
      this.pad.off()
      this.logEvent('Clicked to sign')
    },
    signed ({ distance }) {
      if (distance) {
        this.panned = true
      }
    },
    approve () {
      if (!this.count.actionable) {
        this.$router.push({ name: 'thanks' })
      } else {
        if (!this.accepted) {
          this.error = true
          return
        }
        if (this.pad.isEmpty() && !this.panned) {
          this.error = true
          return
        }
        this.error = false
        this.setSignature(this.pad.toDataURL())

        this.sendServices()

        this.logEvent('Clicked approve button')
      }
    }
  }
})
</script>

<style lang="scss" scoped>
.background {
  position: relative;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--white);
  @media (min-width: 992px) {
    background-color: var(--grey-light-background);
  }
  .contents {
    width: 600px;
    max-width: 100%;
    @media (min-width: 992px) {
      padding: 1rem;
    }
    .card {
      padding: 1rem;
      background-color: var(--white);
      .row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.indented {
          padding-left: 3rem;
          .item {
            margin: 0.5rem 0;
          }
        }
        &.pretax {
          .price {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin: 0;
            color: var(--blue);
            font-weight: 700;
            letter-spacing: 0.0625rem;
            font-family: 'Futura Heavy';
            white-space: nowrap;
          }
        }
        .previous {
          display: flex;
          align-items: center;
          .taxes {
            display: block;
            text-transform: uppercase;
            font-size: 0.7em;
          }
          .toggle {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 0 0 1rem;
            border: none;
            padding: 1.5rem 1rem;
            background-color: var(--white);
            .chevron {
              transition: transform .2s ease-in-out;
              max-width: 2rem;
              &.open {
                transform: rotate(180deg);
                transition: transform .2s ease-in-out;
              }
            }
          }
        }
        .price {
          padding-left: 1rem;
          text-align: right;
          white-space: nowrap;
        }
        & + .row {
          margin-top: 12px;
        }
      }
      .list {
        background-color: var(--grey-light-background);
        padding: 1rem;
        
        .sublet-group {
          .sublet-row {
            padding: 0.25rem 0;
          }
        }
      }
      .divider {
        width: 100%;
        height: 2px;
        margin: 1rem 0;
        background-color: var(--grey-light-background)
      }
      .total .price {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0;
        padding: .5rem;
        border-radius: 500px;
        color: var(--blue);
        font-weight: 700;
        letter-spacing: 0.0625rem;
        font-family: 'Futura Heavy';
        background-color: var(--grey-light-background);
        white-space: nowrap;
      }
      .total.surcharge {
        margin-top: 8px;
        margin-bottom: 8px;
        color: #343741;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        .no-margin {
          margin: 0;
        }
        &.disclaimer {
          color: #69707D;
        }
      }
    }
    .dmpiLinks {
      &:focus {
        outline: none;
      }
    }

    .signature {
      padding: 0 1rem;
      @media (min-width: 992px) {
        padding: 0;
      }
      .legend {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        @media (min-width: 992px) {
          background-color: var(--grey-light-background);
        }
        .prompt {
          font-size: 1.2rem;
          text-transform: uppercase;
        }
        .controls {
          display: flex;
          justify-content: flex-end;
          flex-wrap: wrap;
          .sign, .clear {
            margin: 1px;
            border: none;
            background-color: var(--white);
            text-transform: uppercase;
            font-weight: 700;
            transition: opacity 0.3;
            @media (min-width: 992px) {
              background-color: var(--grey-light-background);
            }
          }
          .sign:disabled {
            opacity: 0.75;
            transition: opacity 0.3;
          }
        }
      }
      .wrapper {
        position: relative;
        .panel {
          width: 100%;
          height: 200px;
          display: block;
        }
        .printed {
          width: 100%;
          max-width: 100%;
          height: 100%;
          max-height: 100%;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: 0;
          padding: 1rem;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 2em;
          font-family: serif;
          font-style: italic;
          background-color: var(--grey-light-background);
          @media (min-width: 992px) {
            background-color: var(--white);
          }
        }
        .sample {
          position: absolute;
          bottom: 1rem;
          left: 1rem;
          pointer-events: none;
        }
      }
    }
    input {
      display: none;
    }
    .checkbox {
      display: inline-flex;
      align-items: center;
      padding: 1rem 0;
      transition: all .2s ease-in;
      .box {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 2.5rem;
        height: 2.5rem;
        margin-right: 1rem;
        border-radius: 3px;
        background-color: var(--grey-medium-background);
        .check {
          max-height: 100%;
          max-width: 100%;
          padding: 0.3rem;
          opacity: 0;
        }
      }
      .text {
        flex-shrink: 2;
        margin: 0;
        .link {
          display: inline;
          text-decoration: none;
          white-space: nowrap;
          color: var(--blue);
        }
      }
    }
    input:checked ~ .checkbox {
      .box {
        background-color: var(--green);
        .check {
          opacity: 1;
        }
      }
    }
    .error {
      .text {
        margin: 0;
        padding: 1rem;
        text-align: center;
        color: var(--red);
      }
    }
  }
}
</style>
